/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CommonAnimButton.vue?vue&type=template&id=01c92370&scoped=true"
import script from "./CommonAnimButton.vue?vue&type=script&lang=js"
export * from "./CommonAnimButton.vue?vue&type=script&lang=js"
import style0 from "./CommonAnimButton.vue?vue&type=style&index=0&id=01c92370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c92370",
  null
  
)

export default component.exports